import { USER } from '@verify/shared-utils';
import { UserRolesData } from 'types';

export const AUDIT_TRAIL_TOOLTIP = 'Grant access to export the audit trail for your whole organization.';

export const isUserPrimaryRoleSelected = (roleId: string | undefined, roles: UserRolesData[]): boolean =>
  roles.some((role) => role.id === roleId && role.name === USER);
